import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';

import SliderNextButton from '../../../../components/SliderButtons/SliderNextButton';
import SliderPrevButton from '../../../../components/SliderButtons/SliderPrevButton';
import CourseCardItem from '../../../../components/CourseCardItem';

import { coursesSliderSettings } from '../../../../config/sliderSettings';

import { Container } from './style';

import { toast } from 'react-toastify';
import { getContents } from '../../../../services/content';
import Content from '../../../../models/content';
import ModalSkeleton from '../Skeleton/Cards';

const RecentelyCourses: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [recentelyCourses, setRecentelyCourses] = useState<Content[]>([]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const recentelyCoursesFilters = { is_library: true, most_recent: true };

        const localCourses = await getContents(recentelyCoursesFilters);

        if (localCourses && localCourses.length) {
          setRecentelyCourses(localCourses);
        }
      } catch (e) {
        toast.error('Erro ao carregar os cursos recentes.');
      }
      setIsLoading(false);
    })();
  }, []);

  return (
    <Container>
      <h2>Cursos adicionados recentemente</h2>

      <Slider
        {...coursesSliderSettings}
        prevArrow={<SliderPrevButton />}
        nextArrow={<SliderNextButton />}
      >
        {isLoading ? (
          <ModalSkeleton />
        ) : recentelyCourses && recentelyCourses.length ? (
          recentelyCourses
            .slice(0, 10)
            .map(course => <CourseCardItem key={course.id} course={course} />)
        ) : (
          <h4 style={{ width: '100%', padding: '15px' }}>
            Não foram encontrados cursos recentes.
          </h4>
        )}
      </Slider>
    </Container>
  );
};

export default RecentelyCourses;
